// src/features/roles/externeConnecte.ts — SCE Issues
// L'externe du panneau d'administration derrière le compte invité connecté, et
// sa société (29/10). Reconnu par son adresse : le compte invité
// `charles.louis_vinci-energies.net#EXT#@…` se lit `charles.louis@vinci-energies.net`
// (adresseNormalisee), celle que l'administrateur a saisie.
//
// Prépare la vue limitée aux équipements de la société — de la lisibilité,
// pas de la sécurité (rien de sensible). Aujourd'hui : affiché dans le menu
// du compte.
//
// Sur le compte RÉEL, jamais en bascule de rôle. Les rôles changés remontent
// l'appli (AvecRoles) : une lecture au rendu suffit.

import { useMemo } from 'react'
import { useAuth } from '@/auth/useAuth'
import { adresseNormalisee } from '@/config/comptesAlias.config'
import { rolesCharges } from '@/config/registreRoles'
import { useVueRole } from '@/features/vue-role/contexte'
import { estCompteInvite, externeDuCompte, type ExterneConnu } from '@/utils/roles'

export function useExterneConnecte(): ExterneConnu | null {
  const { account } = useAuth()
  const { profil } = useVueRole()
  return useMemo(() => {
    // Sans rôles chargés, pas d'externe : le code n'en déclare aucun.
    const roles = rolesCharges()
    if (profil || !account || !roles || !estCompteInvite(account.username)) return null
    return externeDuCompte(adresseNormalisee(account.username), roles)
  }, [account, profil])
}
